<template>
  <div class="investor-info-container">
    <InvestmentInstitutionsModal ref="detailModal" />
    <a-form layout="inline" style="margin-bottom: 26px">
      <a-form-item>
        <a-input-group compact>
          <a-select v-model="queryParam.searchType" style="width: 160px">
            <a-select-option value="id">{{ $t('investorList.tzrID') }}</a-select-option>
            <a-select-option value="mobile">{{ $t('investorList.sjh') }}</a-select-option>
            <a-select-option value="name">{{ $t('investorList.mc') }}</a-select-option>
          </a-select>
          <a-input v-model="queryParam.searchValue" style="width: 150px" :placeholder="$t('enter')" />
        </a-input-group>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="handleSearch">{{ $t('search') }}</a-button>
      </a-form-item>
    </a-form>
    <a-table
      bordered
      :columns="columns"
      :data-source="dataSource"
      :pagination="pagination"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      @change="handleTableChange"
      :rowKey="(record, index) => (record.id ? `${record.id}-${index}` : index)"
    >
      <span slot="hasAuth" slot-scope="text">
        <a-tag :color="text === 1 ? 'green' : 'red'">{{
          text === 1 ? $t('investorList.ysz') : $t('investorList.wsz')
        }}</a-tag>
      </span>
      <span slot="hasKyc" slot-scope="text">
        <a-tag :color="text === 1 ? 'green' : 'orange'">{{
          text === 1 ? $t('investorList.ysg') : $t('investorList.wsg')
        }}</a-tag>
      </span>
      <span slot="status" slot-scope="text">
        <a-badge
          :status="text === 1 ? 'success' : 'error'"
          :text="text === 1 ? $t('investorList.zc') : $t('investorList.jy')"
        />
      </span>
      <span slot="action" class="action-links" slot-scope="text, record">
        <a @click="handleDetail(record)">{{ $t('investorList.xq') }}</a>
        <a-popconfirm
          :title="
            record.status === 1
              ? $t('platformCollection.confirm_disable_investor')
              : $t('platformCollection.confirm_enable_investor')
          "
          @confirm="handleToggleStatus(record)"
        >
          <a>{{ record.status === 1 ? $t('investorList.jy') : $t('investorList.qy1') }}</a>
        </a-popconfirm>
      </span>
    </a-table>
  </div>
</template>

<script>
import { getInvestorList, disableInvestor } from '@/webpublicapi/vietnamBackstage'
import InvestmentInstitutionsModal from './modules/InvestmentInstitutionsModal'
import lang from '@/i18n/lang'

export default {
  name: 'InvestmentInstitutions',
  components: {
    InvestmentInstitutionsModal,
  },
  data() {
    return {
      lang,
      loading: false,
      queryParam: {
        searchType: 'id',
        searchValue: '',
      },
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `${this.$t('components.total')} ${total} ${this.$t('components.items')}`,
      },
    }
  },
  computed: {
    columns() {
      return [
        { title: this.$t('investorList.tzrID'), dataIndex: 'id', align: 'center' },
        { title: this.$t('investorList.mc'), dataIndex: 'name', align: 'center' },
        { title: this.$t('investorList.sjh'), dataIndex: 'mobile', align: 'center' },
        { title: this.$t('investorList.smrz'), dataIndex: 'hasAuth', align: 'center', scopedSlots: { customRender: 'hasAuth' } },
        { title: this.$t('investorList.fxpg'), dataIndex: 'hasKyc', align: 'center', scopedSlots: { customRender: 'hasKyc' } },
        { title: this.$t('investorList.fxdj'), dataIndex: 'level', align: 'center' },
        { title: this.$t('investorList.zt'), dataIndex: 'status', align: 'center', scopedSlots: { customRender: 'status' } },
        { title: this.$t('investorList.yx'), dataIndex: 'email', align: 'center' },
        { title: this.$t('investorList.zcsj'), dataIndex: 'registerTime', align: 'center' },
        { title: this.$t('investorList.cz'), key: 'action', align: 'center', fixed: 'right', scopedSlots: { customRender: 'action' } },
      ]
    },
  },
  created() {
    this.loadData()
  },
  methods: {
    handleDetail(record) {
      this.$refs.detailModal.show(record)
    },
    async handleToggleStatus(record) {
      const nextStatus = record.status === 1 ? 2 : 1
      try {
        const res = await disableInvestor({
          investUserId: record.id,
          status: nextStatus,
        })
        if (res.success || res.respCode === 1000 || res.code === 200) {
          this.$message.success(
            `${nextStatus === 2 ? this.$t('investorList.jy') : this.$t('investorList.qy1')}${this.$t(
              'platformCollection.success_message'
            )}`
          )
          this.loadData()
        } else {
          this.$message.warning(res.respMsg || res.message || this.$t('platformCollection.operation_failed'))
        }
      } catch (e) {
        console.error(e)
        this.$message.error(this.$t('platformCollection.operation_failed'))
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    loadData() {
      this.loading = true
      const params = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        type: 10,
      }
      if (this.queryParam.searchValue) {
        params[this.queryParam.searchType] = this.queryParam.searchValue
      }

      getInvestorList(params)
        .then((res) => {
          if (res.success && res.respData) {
            this.dataSource = res.respData.records || []
            this.dataSource.forEach((item) => {
              item.registerTime = this.transformTime(item.registerTime, 2)
            })
            this.pagination.total = res.respData.total || 0
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';

.action-links {
  display: inline-flex;
  gap: 12px;
}
</style>
